define([
	"dojo/_base/declare",
	"csi/def",
	"csi/locale",
	"csi/model/customView",
	"csi/prefs/_base",
	"csi/heading/Expression"
], function(declare, def, locale, {isCustomViewContainerTypeKey}, prefs, Expression) {

	return declare(Expression, {
		/**
		 * @override
		 * convert URL to localized view name
		 */
		_getValue(ctx, h) {
			const url = ctx.getNode().__Parent__;
			const key = prefs.getContainerKey(url);
			const {type} = def.decomposeViewKey(key);

			if (isCustomViewContainerTypeKey(key) || !type) {
				return "";
			}
			return locale.type(type);
		}
	});
});